import CardViewFormLines from './CardViewFormLines'

const CardViewTabLines = ({ tab, useStore, options, entity }) => {
    return (
        <CardViewFormLines
            section={tab.section}
            linesArray={tab.section.meta.linesArray}
            entity={entity}
            useStore={useStore}
            options={options}
            dispatch={() => {}}
            validated={false}
            toggleExpanded={() => {}}
        />
    )
}

export default CardViewTabLines
